import { render, staticRenderFns } from "./DrawerComponent.vue?vue&type=template&id=03dbcfc9&scoped=true&lang=pug"
import script from "./DrawerComponent.vue?vue&type=script&lang=ts"
export * from "./DrawerComponent.vue?vue&type=script&lang=ts"
import style0 from "./DrawerComponent.vue?vue&type=style&index=0&id=03dbcfc9&lang=scss&scoped=true"
import style1 from "./DrawerComponent.vue?vue&type=style&index=1&id=03dbcfc9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbcfc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03dbcfc9')) {
      api.createRecord('03dbcfc9', component.options)
    } else {
      api.reload('03dbcfc9', component.options)
    }
    module.hot.accept("./DrawerComponent.vue?vue&type=template&id=03dbcfc9&scoped=true&lang=pug", function () {
      api.rerender('03dbcfc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/Drawer/DrawerComponent.vue"
export default component.exports